let locationID: any = null;
let sucessCallbackFunction: any = null;
let errorCallbackFunction: any = null;

class LocationService {
  public isGeolocationAble() {
    return navigator.geolocation;
  }

  public getUserLocation(successCallback: any, errorCallback: any) {
    if (navigator.geolocation) {
      sucessCallbackFunction = successCallback;
      errorCallbackFunction = errorCallback;

      locationID = navigator
        .geolocation
        .watchPosition(this.callSuccessCallback, this.callErrorCallback);
    } else {
      const error = {
        code: 0,
        description: 'Ops, seu navegador não suporta ou bloqueou serviços de Geolocalização.',
      };
      errorCallback(error);
    }
  }

  public callSuccessCallback(pos: any) {
    sucessCallbackFunction(pos);
    navigator.geolocation.clearWatch(locationID);
  }

  public callErrorCallback() {
    errorCallbackFunction();
    navigator.geolocation.clearWatch(locationID);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LocationService();
